import React from 'react';
import OtpVerificationPageWithImage from 'app/Components/Shared/OtpAuthentication/OtpVerificationPageWithImage';
import {isMobile} from 'react-device-detect';
import {gtag4} from 'app/utilities/analytics/tracking';
import {otpOrigin} from 'app/Components/Block/OTPLoginBlock/Assets/variables';

const OtpStepComponent = ({props}) => {
  let epiTitle, otpBanner, otpBannerMainTitle, otpBannerSecondTitle, blockSource;
  console.log(props);
  const gaStep1Display = () => {
    gtag4({
      event: 'SimReplacementP1_Step2_OtpPage',
      step: '1',
      action: 'OtpPage',
      title: epiTitle,
    });
  };
  const gaOnPhoneValidation = () => {
    gtag4({
      event: 'SimReplacementP2_Step2_OtpPhoneButton',
      button: otpTitles.phoneStepButtonText,
      step: '2',
      action: 'OtpPhoneButton',
      title: epiTitle,
    });
  };
  const gaStep2Display = () => {
    gtag4({
      event: 'SimReplacementP2_Step3_OtpCodePage',
      button: otpTitles.otpCodeStepButtonText,
      step: '3',
      action: 'OtpCodePage',
      title: otpTitles.verifyCodeTitle,
    });
  };
  const gaOnOtpCodeValidation = () => {
    gtag4({
      event: 'SimReplacementP2_Step4_OtpButtonClick',
      button: otpTitles.otpCodeStepButtonText,
      step: '4',
      action: 'OtpButtonClick',
      title: otpTitles.verifyCodeTitle,
    });
  };

  if (props.iContent.otp?.value?.length > 0 && props.iContent.otp?.expandedValue) {
    epiTitle = props.iContent.otp?.expandedValue[0]?.stepOneTitle?.value;

    otpBanner = isMobile
      ? props.iContent.otp?.expandedValue[0]?.imageMobile?.value
      : props.iContent.otp?.expandedValue[0]?.imageDesktop?.value;

    otpBannerMainTitle = isMobile
      ? props.iContent.otp?.expandedValue[0]?.bannerMainTitleMobile?.value
      : props.iContent.otp?.expandedValue[0]?.bannerMainTitleDesktop?.value;

    otpBannerSecondTitle = isMobile
      ? props.iContent.otp?.expandedValue[0]?.bannerSecondTitleMobile?.value
      : props.iContent.otp?.expandedValue[0]?.bannerSecondTitleDesktop?.value;
    blockSource = props.iContent.otp?.expandedValue[0]?.blockSource?.value;
  }

  const otpTitles = {
    bannerMainTitle: otpBannerMainTitle,
    bannerSecondTitle: otpBannerSecondTitle,
    verifyPhoneTitle: epiTitle,
    phoneStepButtonText: 'שלחו לי קוד אימות',
    verifyPhoneDescription: 'מה מספר הנייד שלכם?',
    verifyCodeTitle: 'שלחנו קוד אימות, הגיע?',
    otpCodeStepButtonText: 'המשך',
    verifyCodeDescription: 'הקלידו את הקוד שקיבלתם בהודעה',
    blockSource: blockSource,
  };

  return (
    <OtpVerificationPageWithImage
      otpTitles={otpTitles}
      otpOrigin={otpOrigin.GENERIC}
      originProcess={blockSource}
      onAuthenticatedAction={() => props.getSubscribers()}
      isInline={false}
      otpBanner={otpBanner}
      gaStep1Display={gaStep1Display}
      gaOnPhoneValidation={gaOnPhoneValidation}
      gaStep2Display={gaStep2Display}
      gaOnOtpCodeValidation={gaOnOtpCodeValidation}
    />
  );
};

export default OtpStepComponent;
